import { setCurrentChat } from '../store/actions/chat';

export const openBotChat = (chats, dispatch) => {
    const botChat = chats.find(chat => 
        chat.Users && chat.Users.some(user => user.firstName === 'IOP-Bot')
    );
    console.log('botChat==>', botChat);
    if (botChat) {
        dispatch(setCurrentChat(botChat));
    } else {
        const newBotChat = {
            id: '000000',
            chatName: 'IOP-Bot Chat',
            type: 'bot',
            Users: [
                {
                    id: '000000',
                    firstName: 'IOP-Bot',
                    lastName: 'Bot',
                    avatar: 'http://127.0.0.1:3000/bot.svg'
                }
            ],
            Messages: [],
            isBot: true
        };

        dispatch(setCurrentChat(newBotChat));
    }
};
